/**
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na ovladače pro zobrazování video souborů.
 */
class ViewerControllerVideoFactory {
  /**
   * Vytvoří instanci
   * @param {Class.<ViewerControllerVideo>} ViewerControllerVideo
   * @param {HtmlMediaUtil} mediaUtil
   * @param {StretchNative} stretchNative
   * @param {ViewerLifeCycleFactory} viewerLifeCycleFactory
   */
  constructor(
    ViewerControllerVideo,
    mediaUtil,
    stretchNative,
    viewerLifeCycleFactory
  ) {
    // TODO Využít připravené závislosti.
    // - Bude nutný builder pro testy.
    this.ViewerControllerVideo = ViewerControllerVideo;
    this.mediaUtil = mediaUtil;
    this.stretchNative = stretchNative;
    this.viewerLifeCycleFactory = viewerLifeCycleFactory;
  }

  /**
   * Vytvoří nový ovladač.
   * @returns {ViewerControllerVideo}
   */
  create() {
    return new this.ViewerControllerVideo();
  }
}

export default ViewerControllerVideoFactory;
